import PropTypes from "prop-types";

const CategoryContainer = ({ containerClassName, Icon, children }) => (
  <div
    className={`tw-flex tw-items-center tw-gap-8px tw-px-12px tw-h-32px tw-rounded-[8px] ${containerClassName}`}
  >
    <Icon size="l" />
    <span className="tw-text-12d tw-font-semibold">{children}</span>
  </div>
);

export default CategoryContainer;

CategoryContainer.propTypes = {
  Icon: PropTypes.func,
  children: PropTypes.node.isRequired,
  containerClassName: PropTypes.string,
};

CategoryContainer.defaultProps = {
  containerClassName: "",
  Icon: () => null,
};
